import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
})
export default class ModalHeader extends Vue {
    @Prop({ type:String }) header!: '';

}